<template >
    <div class="more-news">
        <!-- <div class="news-tit">热点新闻
            <div class="tit-bottom"></div>
        </div> -->
        <bannerSearch></bannerSearch>
        <div class="news-list">
            <div v-loading="newsLoading">
                <ul class="list" v-if="newsList&&newsList.length>0">
                    <li v-for="item in newsList" :key="item.id">
                        <div class="list-pic"> 
                            <el-image style="width: 100%; height: 100%" :src="item.cover" fit="cover"></el-image>
                        </div>
                        <div class="list-info">
                            <div class="info-tit" @click="toPage('hotNewsDetails',item)">{{ item.title }}</div>
                            <div class="info">
                                <div v-if='item.source'>
                                    <p class="info-label">来源：</p>
                                    <p class="info-value">{{item.source}}</p>
                                </div>
                                <div v-if='item.publishDate'>
                                    <p class="info-label">发布时间：</p>
                                    <p class="info-value">{{item.publishDate}}</p>
                                </div> 
                            </div>
                        </div>
                    </li>
                </ul> 
                <div class="no-data" v-else> 暂无数据～</div>
                <el-pagination  
                    v-if="pageInfo.total>0"
                    class="page-wrap"  
                    @current-change="changePage" 
                    @size-change="sizeChange"
                    background
                    :current-page="pageInfo.pageNum" 
                    :page-count="pageInfo.pageTotal" 
                    :page-size="pageInfo.pageSize"
                    :page-sizes="[10, 20, 30, 50, 100]"
                    :total="pageInfo.total"
                    layout="total, sizes, prev, pager, next, jumper" >
                </el-pagination>
            </div>
            
        </div>
       
    </div>
</template>
<script>
import {hotNewsList} from '../io/api.js'

import bannerSearch from './comps/banner_search.vue';
export default {
    components:{
        bannerSearch,
    },
    data() {
        return {
            newsList:[],
            newsLoading:false,
            pageInfo:{ 
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10, 
            }
        }
    },
    mounted(){
        this.getHotNewsList(1)
    },
    methods:{
        getHotNewsList(num){ 
            this.pageInfo.pageNum=num?num:this.pageInfo.pageNum;
            this.newsLoading=true;
            let params = {
                newsType:'',
                page:this.pageInfo.pageNum,
                limit:this.pageInfo.pageSize
            }
            hotNewsList(params).then(res=>{
                let {code,data,msg} = res.data;
                if(code==0){
                    this.newsList=data.list||[];
                    this.pageInfo.total=data.total||0;
                }else{
                    this.$message.error(msg||'请求失败～')
                }
                this.newsLoading=false;
            })
        },

        toPage(path,item){ 
            let url = this.$router.resolve({
                path: path, 
                query:{
                    changeflag: 5,
                    id:item.id
                } 
            })
            this.$windowOpen({ url:url.href,isLogin:false} )
            // this.$router.push({
            //     path: path, 
            //     query: {
            //         id: item.id,
            //         changeflag: item.changeflag||5
            //     }
            // })
        },
        changePage(num) {
            this.pageInfo.pageNum = num; 
            this.getHotNewsList()
        },
        sizeChange(val) {
             this.pageInfo.pageSize=val;
             this.getHotNewsList()
        },
    }
}
</script>
<style lang="less">
.more-news{ 
    .news-list { 
        width: 1200px;
        margin:40px auto; 
        .list{
            li{
                display: flex;
                padding-bottom: 20px;
                border-bottom: 1px solid #C0D9F6;
                margin-bottom: 20px; 
                // &:hover{
                //     background: #EAF1FF;
                //     box-shadow: 0px 2px 4px 0px rgba(22,93,255,0.04);
                // }
                .list-pic{
                    width: 240px;
                    height: 140px;
                    margin-right: 20px;
                    border-radius: 6px;
                    overflow: hidden;
                }
                .list-info{
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    .info-tit{
                        font-size: 16px;
                        font-weight: bold;
                        margin-bottom: 20px;
                        cursor: pointer;
                        &:hover{
                            color: #000;
                        }
                    }
                    .info{
                        display: flex;  
                        >div{
                            display: flex;
                            align-items: center;
                            margin-right:20px ;
                        }
                    }
                }
            }

        }
        .no-data{
            text-align: center;
            font-size: 16px;

            padding:80px 0 120px;
        }
    }

} 
</style>